<template lang="html">
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn color="green" v-on="on" icon>
        <v-icon>check_circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Accepting to  TAKT.community</span>
      </v-card-title>
      <v-card-text>
        Are you sure, you want to accept and upload this to the community?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="closeDialogEmitEvent()">Accept</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CommunityAcceptDialog',
  props: ['el'],
  data: () => ({
    dialog: false
  }),
  methods: {
    closeDialogEmitEvent(){
      this.$emit('acceptCommunityClick', {
        el: this.el
      });
      this.dialog = false;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
